// GlobalToastNotifications.jsx - Renders toast notifications at the app level
import React from 'react';
import ToastNotification from './ToastNotification';
import { useToastNotificationContext } from './ToastNotificationContext';

const GlobalToastNotifications = () => {
  const { notifications, removeNotification } = useToastNotificationContext();

  return (
    <ToastNotification
      notifications={notifications}
      onClose={removeNotification}
    />
  );
};

export default GlobalToastNotifications;
